module.exports = __webpack_public_path__ + "img/V lat Izq.46e11301.png";